import React, { useState, useEffect } from "react";
import { useAppSelector } from "../redux/hooks";
import { menuState } from "../redux/slice/MenuSlice";
import { onMenuLayout } from "../controller/SecurityController";
import { MenuGroupModel } from "../dto/MenuGroupModel";
import { MenuLayoutListModel } from "../dto/MenuLayoutList/MenuLayoutListModel";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import toast, { Toaster } from 'react-hot-toast';

const MenuLayout = () => {
    const menu = useAppSelector(menuState);
    const [menuLayoutList, setMenuLayoutList] = useState<Array<MenuLayoutListModel>>([]);

    useEffect(() => {
        menuLayoutGet();
    }, []);

    const menuLayoutGet = async () => {
        try {
            const response = await onMenuLayout();
            setMenuLayoutList(response);
        } catch (e: any) {
            toast.error(e.message);
        }
    }

    return (
        <aside className={
            menu.active 
                ? "sidebar-nav-wrapper active"
                : `sidebar-nav-wrapper`
        }
        >
        <div className="navbar-logo">
            <a href="/index" style={{ width: '150px', height: '70px' }}>
                <img src="/images/box.svg" alt="logo" style={{height: '100%', width: '100%'}}/>
            </a>
        </div>
        <nav className="sidebar-nav">
            <ul>
                {
                    menuLayoutList.length > 0 ? menuLayoutList.map((menuGroup, groupIdx) => {
                        return (
                            <li key={groupIdx} className="nav-item nav-item-has-children">
                                <a data-bs-toggle="collapse"
                                data-bs-target={`#ddmenu_${groupIdx}`}
                                aria-controls={`#ddmenu_${groupIdx}`}
                                aria-expanded="false"
                                aria-label="Toggle navigation">
                                    <span className="mdi mdi-arrow-right menu-item"><ArrowForwardIcon fontSize="small"/></span>
                                    <span className="text">{menuGroup.groupName}</span>
                                    {/* <span className="mdi mdi-arrow-right menu-item"><ArrowForwardIcon fontSize="small"/></span> */}
                                </a>
                                <ul id={`ddmenu_${groupIdx}`} className="collapse show dropdown-nav">
                                    {
                                        menuGroup.menuList.map((menu, menuIdx) => {
                                            return (
                                                <li key={menuIdx}>
                                                    <a href={`${menu.url}`} className="menu-link">
                                                        <ArrowForwardIcon fontSize="small"/>
                                                        <span className="mdi mdi-arrow-right menu-item"></span>
                                                        <span className="text fw-500">{menu.menuName}</span>
                                                    </a>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </li>
                        )
                    })
                    : ""
                }
            </ul>
        </nav>
    </aside>
    )
}

export default MenuLayout;